module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "kp-modular-content"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": _vm.themeCdnUri + '/bootstrap-box.css'
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": _vm.themeCdnUri + '/popup.css'
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": _vm.themeActiveStyles
    }
  }), _vm._v(" "), _vm._l((_vm.boxThemeFonts), function(font) {
    return _c('link', {
      attrs: {
        "rel": "stylesheet",
        "href": font
      }
    })
  }), _vm._v(" "), _c('step', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canvasCurrentView === 'steps'),
      expression: "canvasCurrentView === 'steps'"
    }]
  }), _vm._v(" "), _c('fluxogram'), _vm._v(" "), (_vm.canvasCurrentView === 'preview') ? _c('preview') : _vm._e(), _vm._v(" "), _c('trigger-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canvasCurrentView === 'triggerbutton'),
      expression: "canvasCurrentView === 'triggerbutton'"
    }]
  })], 2)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-3679b312!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/Main.vue
 ** module id = 801
 ** module chunks = 1
 **/